import { render, staticRenderFns } from "./wifi.vue?vue&type=template&id=01bbd596&scoped=true&"
import script from "./wifi.vue?vue&type=script&lang=js&"
export * from "./wifi.vue?vue&type=script&lang=js&"
import style0 from "./wifi.vue?vue&type=style&index=0&id=01bbd596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bbd596",
  null
  
)

export default component.exports